import "core-js";
import "jquery-ui";

import * as $ from "jquery";

import CustomElements from "./CustomElements";
import Blackout from "./Components/Blackout";
import MobileNav from "./Components/MobileNav";

import ProductTabs from "./Components/ProductTabs";

CustomElements.add("ge-modal");

$(document).ready(function() {
	console.log("Ready!");

	Blackout.initialize($("#blackout"));

	let nav = new MobileNav(
		$(".toggle-off-canvas"),
		$(".mobile-off-canvas")
	);


	const tabSections = Array.from(document.querySelectorAll(".product-info-tabs")) as HTMLElement[];
	if(tabSections.length) {
		for(const tab of tabSections) {
			let newTab = new ProductTabs(tab);
		}
	}


	setSpacerHeight();

	// Create a placeholder div to match header size, pushes content down.
	let windowResizeEvent = debounce(() => {
		setSpacerHeight();
	}, 100);

	window.addEventListener('resize', windowResizeEvent);
});


function setSpacerHeight() {
	const desktopHeader = <HTMLElement> document.querySelector("header.desktop");
	const mobileHeader = <HTMLElement> document.querySelector("header.mobile");
	const fixedHeaderSpacer = document.getElementById("fixed-header-placeholder");

	fixedHeaderSpacer.style.height = (window.innerWidth >= 640) ? desktopHeader.clientHeight + "px" : mobileHeader.clientHeight + "px";
}


function debounce(func, wait, immediate?) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};